import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function start(): void {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

// -arabic- Arabe : page de droite a gauche AVANT le demarrage (ng-zorro lit le sens a ce moment-la)
// + theme en miroir (assets/css/theme-rtl.css) a la place de theme.css. FR/EN : rien ne change.
let arabic = false;
try { arabic = localStorage.getItem('lang') === 'ar'; } catch { /* navigation privee */ }

if (arabic) {
  document.documentElement.dir = 'rtl';
  document.documentElement.lang = 'ar';
  const ltrTheme = document.querySelector<HTMLLinkElement>('link[rel="stylesheet"][href^="theme"]');
  const rtlTheme = document.createElement('link');
  rtlTheme.rel = 'stylesheet';
  rtlTheme.href = 'assets/css/theme-rtl.css';
  // on attend le theme miroir : jamais d'affichage sans style. S'il ne charge pas, on garde le theme normal.
  rtlTheme.onload = () => { if (ltrTheme) { ltrTheme.disabled = true; } start(); };
  rtlTheme.onerror = () => { rtlTheme.remove(); start(); };
  document.head.appendChild(rtlTheme);
} else {
  start();
}
